import { render, staticRenderFns } from "./adsGroupsPage.vue?vue&type=template&id=78869645&scoped=true&"
import script from "./adsGroupsPage.vue?vue&type=script&lang=js&"
export * from "./adsGroupsPage.vue?vue&type=script&lang=js&"
import style0 from "./adsGroupsPage.vue?vue&type=style&index=0&id=78869645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78869645",
  null
  
)

export default component.exports